// extracted by mini-css-extract-plugin
export default {"upiOption":"UPI_upiOption__jqUZL","upiTitle":"UPI_upiTitle__dKRY9","vpa":"UPI_vpa__ixIe6","imagesHere":"UPI_imagesHere__-oVkx","pleaseNote":"UPI_pleaseNote__zMrKc"};